export default __webpack_public_path__ + "static/media/27.24c3fdde.webp";